module.exports = __webpack_public_path__ + "img/V78.e90c6150.jpg";